
import { useUpdateTask } from '../../api/aws/useUpdateTask'
import { Task } from 'types'
import { useQueryClient } from '@tanstack/react-query'
import { useSyncQueryCache } from 'api/aws/organizations_table/useSyncQueryCache'

export const useHandleTaskUpdate = () => {
  const queryClient = useQueryClient()
  const { mutate: updateTask } = useUpdateTask()
  const { syncTasksCacheAfterBatchUpdate } = useSyncQueryCache()
  const handleTaskUpdate = async (taskIdentifiers: [{ PK: string; SK: string }], updatedData: Partial<Task>) => {
    console.log('taskIdentifiers', taskIdentifiers)
    if (!taskIdentifiers.length) return
    // Ensure all task identifiers have required fields
    const validTasks = taskIdentifiers.filter(task => task.PK && task.SK)
    if (!validTasks.length) {
      console.warn('[handleTaskUpdate] No valid tasks to update.')
      return
    }
    const { PK, SK } = validTasks[0]
    const updateData = { taskPK: PK, taskSK: SK, ...updatedData }
    console.log('Data used for update (single update): ', updateData)

    updateTask(
      { taskPK: PK, taskSK: SK, ...updatedData },
      {
        onSuccess: ({ updatedData }) => {
          console.log('updatedData', updatedData)
          syncTasksCacheAfterBatchUpdate(queryClient, [updatedData])
          // setMonthlyTasks(prev =>
          //   prev.map(task => (task.PK === PK && task.SK === SK ? { ...task, ...updatedData } : task))
          // )
          //           queryClient.invalidateQueries({ queryKey: ['task', taskPK, taskSK] })
          // queryClient.invalidateQueries({ queryKey: ['teamTasks', {}] })
        },
        onError: error => console.error('[handleTaskUpdate] Single update failed', error),
      }
    )
  }
  return { handleTaskUpdate }
}
